import { Button } from "antd"
import { CopyOutlined, DeleteOutlined } from "@ant-design/icons"
import classNames from "classnames"

import { affiliateProgramStore } from "@src/app/affiliateProgramStore"
import { paddingLimit } from "@src/shared/strings"
import { notify } from "../notify"
import css from "./index.module.css"

type Props = {
  id: string
  link: string
  message?: string
  state?: "copy" | "delete"
  style?: React.CSSProperties
}
export const AffiliateLink = ({
  id,
  link,
  message,
  state = "copy",
  style,
}: Props) => {
  const { addLinkToDelete } = affiliateProgramStore

  const handleClick = (): void => {
    if (state === "copy") {
      navigator.clipboard.writeText(link)

      notify.success(message)
    }

    if (state === "delete") {
      addLinkToDelete(id)
    }
  }

  return (
    <div className={css.container} style={style}>
      <span>{paddingLimit(link, 0, 15)}</span>
      <Button
        className={classNames(css.button, {
          [css.deleteButton!]: state === "delete",
        })}
        icon={
          state === "copy" ? (
            <CopyOutlined />
          ) : (
            <DeleteOutlined style={{ color: "#000" }} />
          )
        }
        id="GENERATED_ID_AFFILIATELINK_BUTTON_VOID_1"
        onClick={handleClick}
        size="large"
        type="primary"
      ></Button>
    </div>
  )
}
